<template>
    <div class="lg:w-[936px] mx-auto px-3 lg:px-0 pt-12">
        <section class="mb-8 lg:mb-16">
            <h2>Refund Policy</h2>
            <p class="text-gray-300 text-center mt-2 lg:mt-4 mb-8 lg:mb-16">
                <NuxtLinkLocale to="/" class="underline">AIHomeDesign.com</NuxtLinkLocale>
                <span> Refund Policy</span>
            </p>
            <p class="text-gray-300 text-body-md lg:text-body-lg">
                We at <NuxtLinkLocale to="/" class="underline">AIHomeDesign.com</NuxtLinkLocale> prioritize customer
                satisfaction. If our products don't meet your expectations, we offer a <br />
                straightforward refund process.
            </p>
        </section>
        <section class="mb-8 lg:mb-16">
            <h2 class="text-gray-300 font-bold text-title-md mb-4 lg:mb-6">7-Day Money-Back Guarantee:</h2>
            <p class="text-gray-300 text-body-md lg:text-body-lg mb-4">
                We're committed to the quality of our products, and we believe you'll love them. However, if you're
                unsatisfied for any reason, we offer a money-back guarantee under the following conditions:
            </p>
            <ul class="text-gray-300 text-body-sm lg:text-body-lg mb-6 list-disc px-6 lg:px-8">
                <li>This offer is available to first-time subscribers only.</li>
                <li>
                    Requests for cancellation and refund must be made within the <b>first 7-days</b> of your purchase
                    date.
                </li>
                <li>You have <b>generated 3 or fewer</b> times to test our services.</li>
                <li>Input packs are non-refundable.</li>
            </ul>

            <p class="text-gray-300 text-body-sm lg:text-body-lg mb-1">
                * This applies to both monthly and yearly plans.
            </p>
            <p class="text-gray-300 text-body-sm lg:text-body-lg mb-4 leading-6">
                * Please send your cancellation and refund request to support@aihomedesign.com. Ensure you provide all
                necessary details to facilitate the process.
            </p>
        </section>
        <section>
            <h2 class="text-gray-300 font-bold text-title-md mb-4 lg:mb-6">Human Virtual Staging's Refund Policy:</h2>
            <p class="text-gray-300 text-body-md lg:text-body-lg mb-4">
                We stand by the quality of our “Human Virtual Staging” service and believe you'll be satisfied with the
                results. However, Refunds are applicable to all users who are dissatisfied with the delivered image or
                experience delays in their orders, despite the opportunity for unlimited revisions. if you're not
                completely happy for any reason, we offer a full refund with the following conditions:
            </p>
            <ul class="text-gray-300 text-body-sm lg:text-body-lg mb-6 list-disc px-6 lg:px-8">
                <li>Refund requests must be submitted within 48 hours after the order delivery.</li>
                <li>Users are eligible for a refund if they have not requested revisions more than one times.</li>
                <li>Commercial use of the product is not permitted if a refund is issued.</li>
                <li>For bulk orders, the refund policy will be checked and applied per order item.</li>
            </ul>
            <p class="text-gray-300 text-body-sm lg:text-body-lg mb-4">
                Please keep in mind that the refunding process begins after verification and may take up to 10 days due
                to banking processes. To request a refund, please email <a
                    class="underline"
                    href="mailto:support@aihomedesign.com"
                    >support@aihomedesign.com</a
                > with all necessary details including order time.
            </p>
        </section>
        <section class="mb-12 lg:mb-16 lg:mt-16 mt-8">
            <h2 class="text-gray-300 font-bold text-title-md mb-4">Standard Cancellation:</h2>
            <p class="text-gray-300 text-body-sm lg:text-body-lg">
                In case you're not meeting the aforementioned conditions, you can still cancel your subscription plan.
                <br />
                The cancellation process will start as soon as your current plan ends. For more details on the regular
                cancellation schedule, please refer to our
                <NuxtLinkLocale to="/terms-and-conditions" class="underline">Terms and Conditions</NuxtLinkLocale>.
                <br />
                To cancel your account simply click on the three dots next to your username and click on “Billing.”
                There you can find “Cancel Auto-Renewal” next to “Change Payment Method.”
            </p>
        </section>
    </div>
</template>

<script setup lang="ts">
const { t } = useI18n();

useHead({
    title: t("pages_refund_meta_title").replace("/", "|"),
    meta: [
        {
            name: "description",
            content: t("pages_refund_meta_desc"),
        },
    ],
});
</script>
